import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { makeMe } from "./slices/me";

const createAppStore = () => {
    const me = makeMe();

    return { me };
};

export const store = createAppStore();

const context = createContext<typeof store | null>(null);

export const AppProvider = context.Provider;

export const useApp = () => {
    const state = useContext(context);

    if (!state) {
        throw new Error("There's no Provider for App Context");
    }

    return state;
};

export const getMe = () => store.me;
